export default __webpack_public_path__ + "static/media/forward-arrow.1cc2e2bc.svg";